import { IDetailedListing } from './detailed.listing.types';

export class DetailedListing implements IDetailedListing {
    rowId: string;
    dateOfExpenses: Date
    budgetLine: string
    description: string
    currency: number
    amountInOriginalCurrency: number
    exchangeRate: number
    amountInEUR: number
    organization: string
    receiptNumber: string
    isBankingCharges: boolean

    constructor(list: IDetailedListing) {
        this.rowId = list.rowId;
        this.dateOfExpenses = list.dateOfExpenses;
        this.budgetLine = list.budgetLine
        this.description = list.description
        this.currency = list.currency
        this.amountInOriginalCurrency = list.amountInOriginalCurrency
        this.exchangeRate = list.exchangeRate
        this.amountInEUR = list.amountInEUR
        this.organization = list.organization
        this.receiptNumber = list.receiptNumber
        this.isBankingCharges = list.isBankingCharges || false
    }
}